import { render, staticRenderFns } from "./IconWidgete.vue?vue&type=template&id=4a24ead1&scoped=true"
import script from "./IconWidgete.vue?vue&type=script&lang=js"
export * from "./IconWidgete.vue?vue&type=script&lang=js"
import style0 from "./IconWidgete.vue?vue&type=style&index=0&id=4a24ead1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a24ead1",
  null
  
)

export default component.exports